import initialState from './MonitorsInitialState';
import reducers from './MonitorsReducer';

export default {
  initialState,
  reducers,
};
